import React, { useState } from 'react';
import RichTextEditor from '../RichTextEditor';
import './PlayerUpdateForms.css';

/**
 * PostThoughtForm - Form for players to post personal thoughts/reflections
 * Now uses RichTextEditor for formatted thoughts
 */
const PostThoughtForm = ({ onSubmit, onCancel }) => {
  const [thoughtText, setThoughtText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Extract plain text from HTML for validation
  const getPlainText = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.innerText || '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const plainText = getPlainText(thoughtText);
    if (!plainText.trim()) {
      setError('Thought cannot be empty');
      return;
    }
    if (plainText.length > 500) {
      setError('Thought must be less than 500 characters');
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(thoughtText);
    } catch (err) {
      setError(err.message || 'Failed to post thought');
      setSubmitting(false);
    }
  };

  return (
    <form className="player-update-form thought-form" onSubmit={handleSubmit}>
      <div className="form-header">
        <h4>💭 Post a Thought</h4>
        <button
          type="button"
          className="update-form-close"
          onClick={onCancel}
        >
          ✕
        </button>
      </div>

      {error && (
        <div className="form-error">
          ⚠️ {error}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="thought-text">What's On Your Mind?</label>
        <RichTextEditor
          value={thoughtText}
          onChange={setThoughtText}
          maxCharacters={500}
          placeholder="Share your coaching thoughts, progress updates, or personal reflections..."
          disabled={submitting}
        />
        <p className="form-hint">
          💡 Ideas: What did you learn today? How did you feel about your practice? What's your next goal?
        </p>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn-cancel"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-submit"
          disabled={submitting || !thoughtText.trim()}
        >
          {submitting ? 'Posting...' : 'Post Thought'}
        </button>
      </div>
    </form>
  );
};

export default PostThoughtForm;
